import { createSlice, PayloadAction } from '@reduxjs/toolkit'

/** Screens inside the Help & feedback sidebar tab. */
export type SupportView = 'home' | 'bug' | 'feedback' | 'help' | 'shortcuts' | 'contact'

export type SupportPanelStateType = {
    view: SupportView
}

const initialState: SupportPanelStateType = {
    view: 'home'
}

// Kept in Redux (not component state) so the panel comes back to the same screen after it is
// hidden for a screenshot or recording, and so other features can deep-link into a screen.
const supportPanelSlice = createSlice({
    name: 'supportPanel',
    initialState,
    reducers: {
        setSupportView(state, action: PayloadAction<SupportView>) {
            state.view = action.payload
        }
    }
})

export const { setSupportView } = supportPanelSlice.actions

export default supportPanelSlice.reducer
